/** Format API interviewScheduleDisplay object (or legacy string) for inline text. */
export function formatInterviewScheduleDisplayLabel(display) {
  if (!display) return '';
  if (typeof display === 'string') return display;
  const parts = [];
  if (display.dateLabel && display.timeLabel) {
    const tz = display.timezoneLabel ? ` (${display.timezoneLabel})` : '';
    parts.push(`${display.dateLabel} at ${display.timeLabel}${tz}`);
  } else if (display.iso) {
    parts.push(display.iso);
  }
  if (display.typeLabel) parts.push(display.typeLabel);
  if (display.statusLabel) parts.push(display.statusLabel);
  return parts.join(' · ');
}
